import { useQuery } from "@tanstack/react-query";
import { getLogs } from "../api";

export const useGetLogs = (page = 1, pageSize = 10, userIds = [], options = {}) => {
  const { type, ...queryOptions } = options;
  return useQuery({
    queryKey: ["logs", page, pageSize, userIds, type],
    queryFn: () => getLogs(page, pageSize, userIds, type),
    keepPreviousData: true,
    ...queryOptions,
  });
};

